import React from 'react';

export const WEEK_DAYS = [
  { value: 0, label: 'الأحد' },
  { value: 1, label: 'الاثنين' },
  { value: 2, label: 'الثلاثاء' },
  { value: 3, label: 'الأربعاء' },
  { value: 4, label: 'الخميس' },
  { value: 5, label: 'الجمعة' },
  { value: 6, label: 'السبت' },
];

export const FREQUENCY_AR = { daily: 'يومي', weekly: 'أسبوعي', monthly: 'شهري' };

export function repeatSummary(repeat) {
  if (!repeat || !repeat.frequency) return 'لا يتكرر';
  const at = repeat.time_of_day ? ` الساعة ${String(repeat.time_of_day).slice(0, 5)}` : '';
  if (repeat.frequency === 'weekly') {
    const days = (repeat.days_of_week || []).map(d => WEEK_DAYS[d]?.label).filter(Boolean);
    return days.length ? `أسبوعياً: ${days.join('، ')}${at}` : `أسبوعياً${at}`;
  }
  if (repeat.frequency === 'monthly') {
    return `شهرياً يوم ${repeat.day_of_month || 1}${at}`;
  }
  return `يومياً${at}`;
}

/**
 * ضبط التكرار من داخل المهمة نفسها — القالب يُبنى من بيانات المهمة،
 * والتكرار الأسبوعي يقبل أكثر من يوم.
 */
export default function RepeatPicker({ value, onChange }) {
  const repeat = value || {};
  const set = (patch) => onChange({ ...repeat, ...patch });

  const toggleDay = (day) => {
    const days = repeat.days_of_week || [];
    set({ days_of_week: days.includes(day) ? days.filter(d => d !== day) : [...days, day].sort((a, b) => a - b) });
  };

  return (
    <div>
      <select
        className="form-select"
        value={repeat.frequency || ''}
        onChange={e => {
          const frequency = e.target.value;
          if (!frequency) return onChange(null);
          set({ frequency, time_of_day: repeat.time_of_day || '09:00' });
        }}
      >
        <option value="">لا يتكرر</option>
        <option value="daily">يومي</option>
        <option value="weekly">أسبوعي</option>
        <option value="monthly">شهري</option>
      </select>

      {repeat.frequency === 'weekly' && (
        <div className="weekday-picker">
          {WEEK_DAYS.map(d => (
            <button
              key={d.value}
              type="button"
              className={`weekday${(repeat.days_of_week || []).includes(d.value) ? ' on' : ''}`}
              onClick={() => toggleDay(d.value)}
            >
              {d.label}
            </button>
          ))}
        </div>
      )}

      {repeat.frequency === 'monthly' && (
        <div className="form-row" style={{ marginTop: 8 }}>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">يوم الشهر</label>
            <input
              className="form-input"
              type="number"
              min="1"
              max="31"
              value={repeat.day_of_month || ''}
              onChange={e => set({ day_of_month: e.target.value ? Number(e.target.value) : null })}
            />
          </div>
        </div>
      )}

      {repeat.frequency && (
        <div className="form-group" style={{ marginTop: 8, marginBottom: 0 }}>
          <label className="form-label">وقت التوليد</label>
          <input
            className="form-input"
            type="time"
            value={String(repeat.time_of_day || '09:00').slice(0, 5)}
            onChange={e => set({ time_of_day: e.target.value })}
          />
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
            تُولَّد نسخة جديدة من هذه المهمة في كل موعد. يظهر التكرار في صفحة «المهام المتكرّرة» لتعديله أو إنهائه.
          </div>
        </div>
      )}
    </div>
  );
}
